module.exports = __webpack_public_path__ + "static/media/mulherfooter.6ba872d1.png";